// extracted by css-extract-rspack-plugin
export default {"button":"DefaultIconButton_button__eh1Kn","isDefault":"DefaultIconButton_isDefault__bQNM+"};